export var EatTypeEnum;
(function (EatTypeEnum) {
    EatTypeEnum["Dinein"] = "dinein";
    EatTypeEnum["Togo"] = "togo";
    EatTypeEnum["Delivery"] = "delivery";
    EatTypeEnum["Mall"] = "mall";
    EatTypeEnum["Pickup"] = "pickup";
    EatTypeEnum["CarSide"] = "carside";
})(EatTypeEnum || (EatTypeEnum = {}));
export var AppTypeEnum;
(function (AppTypeEnum) {
    AppTypeEnum["Mobile"] = "Mobile";
    AppTypeEnum["Pos"] = "Pos";
})(AppTypeEnum || (AppTypeEnum = {}));
export var ChannelEnum;
(function (ChannelEnum) {
    ChannelEnum["Pos"] = "pos";
    ChannelEnum["Mobile"] = "mobile";
    ChannelEnum["SelfDelivery"] = "selfDelivery";
    ChannelEnum["BuyTogether"] = "buyTogether";
    ChannelEnum["CallPos"] = "callPos";
})(ChannelEnum || (ChannelEnum = {}));
export var StatusEnum;
(function (StatusEnum) {
    StatusEnum["Disable"] = "disable";
    StatusEnum["Enable"] = "enable";
    StatusEnum["Mutex"] = "mutex";
})(StatusEnum || (StatusEnum = {}));
export var ActivityTypeEnum;
(function (ActivityTypeEnum) {
    ActivityTypeEnum["SingleItemDiscount"] = "singleItemDiscount";
    ActivityTypeEnum["OrderDiscount"] = "orderDiscount";
    ActivityTypeEnum["NthItemNDiscount"] = "nthItemNDiscount";
    ActivityTypeEnum["DesignatedItemDiscount"] = "designatedItemDiscount";
    ActivityTypeEnum["FullItemNFree"] = "fullItemNFree";
    ActivityTypeEnum["FullItemNFreePromoCode"] = "fullItemNFreePromoCode";
    ActivityTypeEnum["OrderSwapBuy"] = "orderSwapBuy";
    ActivityTypeEnum["SingleItemSwapBuy"] = "singleItemSwapBuy";
    ActivityTypeEnum["SingleItemSwapBuyPromoCode"] = "singleItemSwapBuyPromoCode";
    ActivityTypeEnum["LadderDiscount"] = "ladderDiscount";
    ActivityTypeEnum["SpecialOffer"] = "specialOffer";
    ActivityTypeEnum["ExpressFeeDiscount"] = "expressFeeDiscount";
    ActivityTypeEnum["GroupBuy"] = "groupBuy";
})(ActivityTypeEnum || (ActivityTypeEnum = {}));
export var ProductRelationEnum;
(function (ProductRelationEnum) {
    ProductRelationEnum["All"] = "all";
    ProductRelationEnum["Included"] = "included";
    ProductRelationEnum["Excluded"] = "excluded";
})(ProductRelationEnum || (ProductRelationEnum = {}));
export var DiscountTypeEnum;
(function (DiscountTypeEnum) {
    DiscountTypeEnum["DiscountFee"] = "discountFee";
    DiscountTypeEnum["DiscountRate"] = "discountRate";
    DiscountTypeEnum["SpecialOffer"] = "specialOffer";
    DiscountTypeEnum["MemberPrice"] = "memberPrice";
})(DiscountTypeEnum || (DiscountTypeEnum = {}));
export var InteractiveScenes;
(function (InteractiveScenes) {
    InteractiveScenes["MENU_LIST"] = "menu_list";
    // SHOPPING_CART = 'shopping_cart', // 购物车(废弃)
    InteractiveScenes["ORDER_SETTLEMENT"] = "order_settlement";
    InteractiveScenes["MALL_MENU_LIST"] = "mall_menu_list";
    InteractiveScenes["MALL_ORDER_SETTLEMENT"] = "mall_order_settlement";
})(InteractiveScenes || (InteractiveScenes = {}));
export var PubSubTypeEnum;
(function (PubSubTypeEnum) {
    PubSubTypeEnum["Activity"] = "activity";
    PubSubTypeEnum["Plan"] = "plan";
    PubSubTypeEnum["MemberPrice"] = "memberPrice";
    PubSubTypeEnum["Config"] = "config";
})(PubSubTypeEnum || (PubSubTypeEnum = {}));
export var OffTypeEnum;
(function (OffTypeEnum) {
    OffTypeEnum["Activity"] = "activity";
    OffTypeEnum["Plan"] = "plan";
    OffTypeEnum["MemberCard"] = "memberCard";
    OffTypeEnum["Coupon"] = "coupon";
    OffTypeEnum["Floor"] = "floor";
    OffTypeEnum["IntegralMoney"] = "integralMoney";
    OffTypeEnum["PromoCode"] = "promoCode";
    OffTypeEnum["MemberPrice"] = "memberPrice";
    OffTypeEnum["DesignatedItem"] = "designatedItem";
    OffTypeEnum["LadderDiscount"] = "ladderDiscount";
    // LadderCoupon = 'ladderCoupon', // 阶梯优惠券,组合优惠券
    OffTypeEnum["GroupBuy"] = "groupBuy";
})(OffTypeEnum || (OffTypeEnum = {}));
export var CalActivityEnum;
(function (CalActivityEnum) {
    CalActivityEnum["Express"] = "express";
})(CalActivityEnum || (CalActivityEnum = {}));
export var CouponTypeEnum;
(function (CouponTypeEnum) {
    CouponTypeEnum["Order"] = "order";
    CouponTypeEnum["Item"] = "item";
    CouponTypeEnum["Cash"] = "cash";
    CouponTypeEnum["Designate"] = "designate";
    CouponTypeEnum["Ladder"] = "ladder";
    CouponTypeEnum["Express"] = "express";
})(CouponTypeEnum || (CouponTypeEnum = {}));
export var UsePromoCodeStatusEnum;
(function (UsePromoCodeStatusEnum) {
    UsePromoCodeStatusEnum["Effective"] = "effective";
    UsePromoCodeStatusEnum["Unused"] = "unused";
    UsePromoCodeStatusEnum["Ineffective"] = "ineffective";
})(UsePromoCodeStatusEnum || (UsePromoCodeStatusEnum = {}));
export var FloorPayTypeEnum;
(function (FloorPayTypeEnum) {
    FloorPayTypeEnum["Cash"] = "cash";
    FloorPayTypeEnum["All"] = "all";
})(FloorPayTypeEnum || (FloorPayTypeEnum = {}));
export var FloorTypeEnum;
(function (FloorTypeEnum) {
    FloorTypeEnum["FloorInt"] = "floorInt";
    FloorTypeEnum["FloorHalf"] = "floorHalf";
    FloorTypeEnum["FloorTenth"] = "floorTenth";
})(FloorTypeEnum || (FloorTypeEnum = {}));
export var BoEnum;
(function (BoEnum) {
    BoEnum["CN"] = "cn";
    BoEnum["US"] = "us";
    BoEnum["DE"] = "de";
    BoEnum["IT"] = "it";
})(BoEnum || (BoEnum = {}));
export var MemberTypeEnum;
(function (MemberTypeEnum) {
    MemberTypeEnum["Member"] = "member";
    MemberTypeEnum["User"] = "user";
    MemberTypeEnum["Virtual"] = "virtual";
})(MemberTypeEnum || (MemberTypeEnum = {}));
export var DeductionRule;
(function (DeductionRule) {
    DeductionRule["RechargeFirst"] = "rechargeFirst";
    DeductionRule["GiveFirst"] = "giveFirst";
    DeductionRule["Average"] = "average";
})(DeductionRule || (DeductionRule = {}));
export var CardTypeEnum;
(function (CardTypeEnum) {
    CardTypeEnum["Card"] = "card";
    CardTypeEnum["Giftcard"] = "giftcard";
})(CardTypeEnum || (CardTypeEnum = {}));
export var RemindTypeEnum;
(function (RemindTypeEnum) {
    RemindTypeEnum["Wechat"] = "wechat";
    RemindTypeEnum["Sms"] = "sms";
    RemindTypeEnum["Email"] = "email";
})(RemindTypeEnum || (RemindTypeEnum = {}));
export var CalTimeTypeEnum;
(function (CalTimeTypeEnum) {
    CalTimeTypeEnum["OrderTimeIncludeStartTime"] = "orderTimeIncludeStartTime";
    CalTimeTypeEnum["OrderTime"] = "orderTime";
    CalTimeTypeEnum["PayTime"] = "payTime";
})(CalTimeTypeEnum || (CalTimeTypeEnum = {}));
export var ProductTypeEnum;
(function (ProductTypeEnum) {
    ProductTypeEnum["Product"] = "product";
    ProductTypeEnum["FixedCombo"] = "FixedCombo";
    ProductTypeEnum["OptionalCombo"] = "OptionalCombo";
    ProductTypeEnum["Express"] = "express";
    ProductTypeEnum["MallProduct"] = "mallProduct";
    ProductTypeEnum["Modifier"] = "modifier";
    ProductTypeEnum["Box"] = "box";
})(ProductTypeEnum || (ProductTypeEnum = {}));
export var BusinessEnum;
(function (BusinessEnum) {
    BusinessEnum["Meal"] = "meal";
    BusinessEnum["Mall"] = "mall";
    BusinessEnum["MemberCard"] = "memberCard";
})(BusinessEnum || (BusinessEnum = {}));
/**
 * 整单换购的状态
 */
export var OrderSwapBuyStatusEnum;
(function (OrderSwapBuyStatusEnum) {
    OrderSwapBuyStatusEnum["Effective"] = "effective";
    OrderSwapBuyStatusEnum["Ineffective"] = "ineffective";
})(OrderSwapBuyStatusEnum || (OrderSwapBuyStatusEnum = {}));
/**
 * 优惠券使用限制
 */
export var UseLimitTypeEnum;
(function (UseLimitTypeEnum) {
    UseLimitTypeEnum["EveryDay"] = "everyDay";
    UseLimitTypeEnum["EveryOrder"] = "everyOrder";
    UseLimitTypeEnum["NoLimit"] = "noLimit";
})(UseLimitTypeEnum || (UseLimitTypeEnum = {}));
export var BalanceDiscountRuleEnum;
(function (BalanceDiscountRuleEnum) {
    BalanceDiscountRuleEnum["HasBalance"] = "hasBalance";
    BalanceDiscountRuleEnum["NoLimit"] = "noLimit";
    BalanceDiscountRuleEnum["OnlyBalancePay"] = "onlyBalancePay";
})(BalanceDiscountRuleEnum || (BalanceDiscountRuleEnum = {}));
export var WhenEffectEnum;
(function (WhenEffectEnum) {
    WhenEffectEnum["Today"] = "today";
    WhenEffectEnum["Tomorrow"] = "tomorrow";
    WhenEffectEnum["Specify"] = "specify";
})(WhenEffectEnum || (WhenEffectEnum = {}));
//# sourceMappingURL=enum.js.map